<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'
        width= '200'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        prop= 'maxTemperature'
        label= '存活温度'
        width= '100'>
        <template slot-scope='scope'>
          {{ scope.row.minTemperature }}-{{ scope.row.maxTemperature }}℃
        </template>
      </el-table-column>
      <el-table-column
        prop= 'minGrowthTemperature'
        label= '适宜温度'
        width= '100'>
        <template slot-scope='scope'>
          {{ scope.row.minSuitableTemperature }}-{{ scope.row.maxSuitableTemperature }}℃
        </template>
      </el-table-column>
      <el-table-column
        prop= 'agrotypeType'
        label= '土壤类型'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'greenhouseType'
        label= '温室类型'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'climateType'
        label= '气候类型'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'biotaGrowthModelId'
        label= '生长模式'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'growthStart'
        label= '阶段开始时间'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'stayTime'
        label= '持续时间'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'sort'
        label= '排序'
        width= '80'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false" top="20px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="6">
            <el-form-item label="极限最低温度" :label-width="formLabelWidth" prop="minTemperature">
              <el-input type="number" v-model.number="form.minTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="适宜最低温度" :label-width="formLabelWidth" prop="minSuitableTemperature">
              <el-input type="number" v-model.number="form.minSuitableTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="适宜最高温度" :label-width="formLabelWidth" prop="maxSuitableTemperature">
              <el-input type="number" v-model.number="form.maxSuitableTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="极限最高温度" :label-width="formLabelWidth" prop="maxTemperature">
              <el-input type="number" v-model.number="form.maxTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="土壤类型" :label-width="formLabelWidth" prop="agrotypeType">
              <el-select v-model="form.agrotypeType" clearable placeholder="请选择">
                <el-option v-for="item in agrotypeTypes" :key="item.val" :label="item.val" :value="item.val"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="温室类型" :label-width="formLabelWidth" prop="greenhouseType">
              <el-select v-model="form.greenhouseType" clearable placeholder="请选择">
                <el-option v-for="item in greenhouseTypes" :key="item.val" :label="item.val" :value="item.val"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="气候类型" :label-width="formLabelWidth" prop="climateType">
              <el-select v-model="form.climateType" clearable placeholder="请选择">
                <el-option v-for="item in climateTypes" :key="item.val" :label="item.val" :value="item.val"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="阶段开始时间" :label-width="formLabelWidth" prop="growthStart">
              <el-date-picker v-model="form.growthStart" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排序" :label-width="formLabelWidth" prop="sort">
              <el-input type="number" v-model.number="form.sort" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="持续时间" :label-width="formLabelWidth" prop="stayTime">
              <el-input type="number" v-model.number="form.stayTime" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input type="textarea" v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="封面图像" :label-width="formLabelWidth" prop="imageMd5">
          <el-upload class="upload-demo" drag action="#" accept="png,jpg,jpeg" :limit=1 :http-request="uploadImage" :file-list="fileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  props: {
    biotaId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  watch: {
    biotaId: {
      handler (newV, oldV) {
        this.biotaId = newV
        this.query()
      },
      immediate: true
    }
  },
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        descr: null,
        minTemperature: null,
        minSuitableTemperature: null,
        maxSuitableTemperature: null,
        maxTemperature: null,
        biotaId: null,
        agrotypeType: null,
        greenhouseType: null,
        climateType: null,
        biotaGrowthModelId: null,
        sort: null,
        imageMd5: null,
        growthStart: null,
        stayTime: null
      },
      rules: {
        minTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}],
        minSuitableTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}],
        maxSuitableTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}],
        maxTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}],
        biotaId: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        biotaGrowthModelId: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        sort: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        growthStart: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}],
        stayTime: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      imageMd5: null,
      fileList: [],
      apiUrl: '',
      agrotypeTypes: [],
      greenhouseTypes: [],
      climateTypes: []
    }
  },
  created () {
    this.apiUrl = this.$global.apiUrl
    this.query()
    this.loadAgrotypeType()
    this.loadGreenhouseType()
    this.loadClimateType()
  },
  methods: {
    loadAgrotypeType () {
      let that = this
      requestService.get('/dict/listByKkey?kkey=agrotype_type', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.agrotypeTypes = res.data.body
      })
    },
    loadGreenhouseType () {
      let that = this
      requestService.get('/dict/listByKkey?kkey=greenhouse_type', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.greenhouseTypes = res.data.body
      })
    },
    loadClimateType () {
      let that = this
      requestService.get('/dict/listByKkey?kkey=climate_type', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.climateTypes = res.data.body
      })
    },
    uploadImage (file) {
      let that = this
      let formData = new FormData()
      formData.append('file', file.file)
      requestService.post('/file/add/single', formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.form.imageMd5 = res.data.body.md5
        console.log(that.form)
      })
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/biotaGrowthStage/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/biotaGrowthStage/listPage?current=${that.current}&pageSize=${that.pageSize}&biotaId=${this.biotaId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.form.biotaId = this.biotaId
      if (this.form.imageMd5) {
        this.fileList.push({name: this.form.imageMd5, url: this.apiUrl + '/file/getOneByByte?md5=' + this.form.imageMd5})
      }
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.form.biotaId = this.biotaId
      this.fileList = []
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/biotaGrowthStage/add'
          if (that.form.id) {
            url = '/biotaGrowthStage/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/biotaGrowthStage/Index.vue